import * as React from 'react'

import Page from '../components/Page'
import Container from '../components/Container'
import IndexLayout from '../layouts'
import helpMovie from '../assets/help.mp4';
import ReactPlayer from 'react-player'

const IndexPage = () => (
  <IndexLayout>
    <Page>
      <Container>
        <h1>アプリの使い方</h1>
        {/* <source src={helpMovie} type="video/mp4" /> */}
        <ReactPlayer url={helpMovie} playing={true} />
      </Container>
    </Page>
  </IndexLayout>
)

export default IndexPage
